<div *ngIf="inProgress">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  loading....
</div>

<div class="center-content2 armabox">
  <div class="table-header armarow header">
    <div class="medium-border-arma-color table-title-fit-content">
      {{ 'Mes Bons de livraison' | translate }} ({{HTML_CURRENT_SITE}})
    </div>

    <span class="filler"></span>

    <div *ngIf="!inProgress && HTML_TABLE_DATASOURCE.data?.length == 0" class="medium-border-arma-color table-title-fit-content">
      {{'Aucun bon de livraison trouvé !' | translate}}
    </div>

    <div>
      <mat-form-field style="margin: auto; min-width: 350px; max-height: 50px;">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="mTableFilter.globalFilter" (keyup)="triggerFilter()" placeholder="{{'Rechercher' | translate}}">
      </mat-form-field>
    </div>

    <span class="filler"></span>

    <div class="header-button-row">
      <button mat-raised-button [matMenuTriggerFor]="menuParameter">
        <mat-icon aria-hidden="false" aria-label="settings">settings</mat-icon>
        <label>{{'Paramètres' | translate}}</label>
      </button>

      <button mat-button class="fit-h-centered-btn"
              [disabled]="HTML_TABLE_DATASOURCE.data.length == 0 || inProgress"
              (click)="downloadAll()">
        {{ 'Télécharger tout' | translate }}
      </button>
    </div>

  </div>

  <table mat-table matSort
         [dataSource]="HTML_TABLE_DATASOURCE"
         style="max-width: 100%; margin: auto"
         class="mat-elevation-z8 medium-border-arma-color cmat-add-border no-table-padding">

    <!-- DOC_NO -->
    <ng-container [matColumnDef]="MAT_COLUMN_DOC_NO">
      <th style="min-width: 50px" class="cmat-center-btn" mat-header-cell *matHeaderCellDef mat-sort-header> {{'N° Bon' | translate}} </th>
      <td mat-cell *matCellDef="let element"><div>{{asDnList(element).DOC_NO}}</div></td>
    </ng-container>

    <!-- DOC_DATE -->
    <ng-container [matColumnDef]="MAT_COLUMN_DOC_DATE">
      <th style="width: 100px;" mat-header-cell *matHeaderCellDef>
        {{'Date' | translate}}
        <app-filter-component [columnFilterDate]="mTableFilter.getColumnFilterDate(MAT_COLUMN_DOC_DATE)" (onChange)="triggerFilter()"></app-filter-component>
      </th>
      <td mat-cell *matCellDef="let element"><div>{{asDnList(element).DOC_DATE}}</div></td>
    </ng-container>

    <!-- DOC_LIST_ORDER -->
    <ng-container [matColumnDef]="MAT_COLUMN_ORDER_CODE">
      <th style="width: 200px" class="cmat-center-btn" mat-header-cell *matHeaderCellDef mat-sort-header> {{'Décorticage' | translate}} </th>
      <td class="coll-alin-right" mat-cell *matCellDef="let element">
        <div *ngFor="let item of asDnList(element).ArrayOrder">
          <ng-template [ngIf]="item.analysisCode">
            {{item.analysisCode}} ({{item.analysisWeight | number: '1.0-0'}} {{'kg' | translate}})
          </ng-template>
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="MAT_COLUMN_ORDER_CODE_EXT">
      <th style="width: 150px" class="cmat-center-btn" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{'Code externe' | translate}}
        <app-filter-component [columnFilterCheck]="mTableFilter.getColumnFilterChecklist(MAT_COLUMN_ORDER_CODE_EXT)" (onChange)="triggerFilter()"></app-filter-component>
      </th>
      <td class="coll-alin-right" mat-cell *matCellDef="let element">
        <div *ngFor="let item of asDnList(element).ArrayOrder">{{item.extAnalysisCode}}</div>
      </td>
    </ng-container>

    <!-- DOC_LIST_DESINATION -->
    <ng-container [matColumnDef]="MAT_COLUMN_ORDER_DESIGNATION">
      <th class="cmat-center-btn" mat-header-cell *matHeaderCellDef mat-sort-header> {{'Désignation' | translate}} </th>
      <td class="coll-alin-left" mat-cell *matCellDef="let element">
        <div *ngFor="let item of asDnList(element).ArrayOrder">{{item.designation}}</div>
      </td>
    </ng-container>

    <!-- DOC_LIST_DRAWING -->
    <ng-container [matColumnDef]="MAT_COLUMN_ORDER_DRAWING">
      <th class="cmat-center-btn" mat-header-cell *matHeaderCellDef mat-sort-header> {{'Plan' | translate}} </th>
      <td class="coll-alin-left" mat-cell *matCellDef="let element">
        <div *ngFor="let item of asDnList(element).ArrayOrder">{{item.planIdPlan}}</div>
      </td>
    </ng-container>

    <!-- DOC_VALUE -->
    <ng-container [matColumnDef]="MAT_COLUMN_DOC_VALUE">
      <th style="min-width: 70px" class="cmat-center-btn" mat-header-cell *matHeaderCellDef mat-sort-header> {{'Poids (kg)' | translate}} </th>
      <td class="coll-alin-right" mat-cell *matCellDef="let element"><div>{{asDnList(element).DOC_VALUE}}</div></td>
    </ng-container>

    <!-- ACTION -->
    <ng-container [matColumnDef]="MAT_COLUMN_DOC_ACTION">
      <th style="width: 1px" mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
      <td mat-cell *matCellDef="let element">
        <button
          style="margin: 0 1px;"
          mat-stroked-button
          (click)="getDN(element, false)"
          matTooltip="{{'Consulter' | translate}}">
          <img height="24px" src="assets/icons/view.png">
        </button>
        <button
          style="margin: 0 1px;"
          mat-stroked-button
          (click)="getDN(element, true)"
          matTooltip="{{'Télécharger' | translate}}">
          <img height="24px" src="assets/icons/download.png">
        </button>
      </td>
    </ng-container>

    <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TABLE_HEADER_COL; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: HTML_TABLE_HEADER_COL;" class="hover-table-smoke"></tr>
  </table>

  <mat-paginator #TablePaginator [pageSize]="50" showFirstLastButtons class="center-content sticky-paginator"></mat-paginator>

</div>

<mat-menu #menuParameter>
  <div (click)="$event.stopPropagation()">
    <mat-checkbox [(ngModel)]="visibilityColumn.displayAnalysis" (change)="updateArrayTableHeader(true)" class="mat-menu-item">{{'Afficher le décorticage' | translate}}</mat-checkbox>
    <mat-checkbox [(ngModel)]="visibilityColumn.displayDnDate" (change)="updateArrayTableHeader(true)" class="mat-menu-item">{{'Afficher la date' | translate}}</mat-checkbox>
    <mat-checkbox [(ngModel)]="visibilityColumn.displayDrawing" (change)="updateArrayTableHeader(true)" class="mat-menu-item">{{'Afficher plan' | translate}}</mat-checkbox>
    <mat-checkbox [(ngModel)]="visibilityColumn.displayWeight" (change)="updateArrayTableHeader(true)" class="mat-menu-item">{{'Afficher le poids' | translate}}</mat-checkbox>
    <mat-checkbox [(ngModel)]="visibilityColumn.displayDesignation" (change)="updateArrayTableHeader(true)" class="mat-menu-item">{{'Afficher la désignation' | translate}}</mat-checkbox>
    <mat-checkbox *ngIf="mHasExtCode" [(ngModel)]="visibilityColumn.displayExternalCode" (change)="updateArrayTableHeader(true)" class="mat-menu-item">{{'Afficher le code externe' | translate}}</mat-checkbox>
  </div>
</mat-menu>
